import { render, staticRenderFns } from "./AuditLogListing.vue?vue&type=template&id=36c71f06&"
import script from "./AuditLogListing.vue?vue&type=script&lang=js&"
export * from "./AuditLogListing.vue?vue&type=script&lang=js&"
import style0 from "./AuditLogListing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports